<nav id="navPanel" class="bg-light border-bottom box-shadow fixed-top navbar-expand-lg">
  <app-header></app-header>
</nav>
<div class="main-panel pt-0 pb-4" style="background-color: #ffffff;">
  <div class="container-fluid" #main [style.padding-top.px]="paddingtop">
    <div class="col-sm-12 px-0 align-self-end">
      <div class="row align-items-center">
        <div class="col-sm-10">
          <h5 class="light-header bold">
            {{ 'USER.LBL_TITLE_DLT_RQS' | translate}}
          </h5>
        </div>
        <!-- Exit button -->
        <!-- <div class="col-sm-2">
          <button type="button" class="btn btn-primary btn-sm float-right" (click)="exitBtnClickEvent()">
            <i class="fas fa-sign-out"></i> Exit
          </button>
        </div> -->
      </div>
      <hr class="mt-0 mb-3" />
    </div>
    <div class="pt-3">
      <div class="container border rounded p-3 bold">
        <form [formGroup]="iSForm">

          <div class="form-group row">
            <label for="clinicname" class="col-sm-2 col-form-label">Clinic Name</label>
            <div class="col-sm-4">
              <input type="text" class="form-control bold" id="clinicname" [hidden]="!isAdminUser"  autocomplete="off"
                     [(ngModel)]="clinicname" formControlName="clinicname" disabled/>
              <ngx-select-dropdown tabindex="0" class="bold" formControlName="clinicfilter" (change)="clinicFilter()"
                                   [multiple]="false"  [(ngModel)]="selectedClinicFilter" [hidden]="isAdminUser"
                                   [config]="{displayKey: 'ClinicName',search: true,height:'200px',placeholder:'Select Clinic',searchOnKey: 'ClinicName' }"
                                   [options]="clinicsforfilter">
              </ngx-select-dropdown>
            </div>
          </div>
          <div class="form-group row">
            <label for="Name" class="col-sm-2 col-form-label">User Name</label>
            <div class="col-sm-4">
              <input type="text" class="form-control bold" id="name"   autocomplete="off"
                     formControlName="name" [(ngModel)]="name" (keyup)="searchBtnClickEvent()"/>
            </div>
            <div class="col-sm-5">
              <div class="form-row">
                <!-- <div class="form-group col-md-0">
                  <button type="button" class="btn btn-primary btn-sm" (click)="searchBtnClickEvent()"> <i class="far fa-search"></i> Search</button>
                </div> -->
                <div class="form-group col-md-0">
                  <button type="button" class="btn btn-primary btn-sm" (click)="cancelBtnClickEvent()"> <i class="far fa-times"></i> Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="pt-3">
      <div class="container border rounded p-3 bold">
        <div id="grid-wrapper" class="col-sm-12 px-0" style="width: 100%; overflow: hidden;">
          <div class="col-sm-12 px-0" >
            <ag-grid-angular style="width: 100%; height: 500px; " class="ag-theme-balham bold"
                             [columnDefs]="columnDefs" (gridReady)="onGridReady($event)" [rowData]="rowData"
                             (gridSizeChanged)="gridSizeChanged($event)" [defaultColDef]="defaultColDef"
                             [animateRows]="true" [isExternalFilterPresent]="isExternalFilterPresent"
                             [doesExternalFilterPass]="doesExternalFilterPass"
                             [headerHeight]="60" [gridOptions]="gridOptions" >
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
